import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hvd89678f4: FaireBrandEntity = {
  token: "b_hvd89678f4",
  type: "brand",
  name: "AwakenedCore",
  avatarUrl:
    "https://cdn.faire.com/fastly/80fcbd2843af033e415c180a7c3e7da1970973d5cf3e28a1c766de5f868cfb2a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/bf1f423776b8e892acb42b1fd8a989c33f1763f5080260b1aa3ced334681e125.png",
  logoUrl:
    "https://cdn.faire.com/fastly/80fcbd2843af033e415c180a7c3e7da1970973d5cf3e28a1c766de5f868cfb2a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bf1f423776b8e892acb42b1fd8a989c33f1763f5080260b1aa3ced334681e125.png",
  location: "Davie, FL, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 14,
  isTopShop: true,
  isInsider: true,
  description:
    "At AwakenedCore, we believe that true wellness begins where science meets consciousness.\n\nOur mission is to reconnect people with their innate life force, the energy that powers every cell, every breath, every moment of presence.\n\nWe formulate cutting-edge wellness supplements that target the body at its deepest level, the cell, to awaken that natural intelligence within. From Hydrogen Tabs, which deliver pure molecular hydrogen for daily cellular energy and recovery, to Methylene Blue, known to enhance cognitive clarity and mitochondrial function, every formula is a ritual of renewal, designed to help you feel vibrant, focused and fully alive.\n\nRooted in research and guided by intention, AwakenedCore bridges modern science with the wisdom of energy. Our purpose is simple, to awaken your core: body, mind, and spirit, and help you rise to your highest potential, one cell at a time.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:03.365Z",
    importedBy: "entity-db-cli",
  },
};
